{
  "info": "Info",
  "negative": "Fejl",
  "positive": "Fuldført"
}
